import styled from '@emotion/styled';
import { SearchBar } from './SearchBar';
import { GoogleAggregate } from './GoogleAggregate';
import { ContactButton } from './ContactUsButton';
import { useGlobal } from '../../hooks';
import { normalizeLinks } from 'rwl-ui/src/utils/normalizeContactLinks';
import { Else, If, Then, When } from 'react-if';
import { useBreakpoint } from '../../providers';
import { AnalyticsTargetLayerAreaProvider, mqUp } from 'rwl-ui';
import { TargetLayerArea } from 'rwl-shared/dist/models/analytics';
import { LocationTitle } from '../NeighborhoodOverviewBanner/LocationTitle';
import { useMapContext } from '../../hooks/MapProvider';
const StyledHeader = styled.div<{
    isBelowSmBreakpoint?: boolean;
    isBumpOutEnabled?: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${({ isBelowSmBreakpoint, isBumpOutEnabled }) =>
        !isBumpOutEnabled &&
        !isBelowSmBreakpoint &&
        `border-bottom: 1px solid var(--rwl-background-level2);`}
    container-type: inline-size;
    container-name: header;
    position: relative;
    height: var(--rwl-header-height);
    ${({ isBumpOutEnabled }) =>
        isBumpOutEnabled
            ? `padding: var(--rwl-spacing-sm) var(--rwl-spacing-lg) var(--rwl-spacing-sm) var(--rwl-spacing-lg);`
            : `padding: var(--rwl-spacing-lg);`}
    ${mqUp('sm')} {
        gap: var(--rwl-spacing-md);
    }
    z-index: 2;
    height: 62px;
`;

export const Header = (): JSX.Element => {
    const { config, brandColor, bumpOutTestEnabled } = useGlobal();
    const { isAboveBreakpoint, isBelowBreakpoint } = useBreakpoint();
    const { neighborhood } = useMapContext();
    const postCodeExists = !!neighborhood?.postcode;
    if (!config) {
        return <StyledHeader />;
    }
    const { contactUs } = normalizeLinks(config?.businessContactInfo);

    return (
        <AnalyticsTargetLayerAreaProvider
            targetLayerArea={TargetLayerArea.HEADER}
        >
            <StyledHeader
                isBelowSmBreakpoint={isBelowBreakpoint('sm')}
                isBumpOutEnabled={bumpOutTestEnabled}
            >
                <If condition={isBelowBreakpoint('sm') && postCodeExists}>
                    <Then>
                        <LocationTitle />
                    </Then>
                    <Else>
                        <SearchBar />
                    </Else>
                </If>
                <When condition={isAboveBreakpoint('sm')}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 'var(--rwl-spacing-md)',
                        }}
                    >
                        <GoogleAggregate />
                        <ContactButton
                            brandColor={brandColor}
                            link={contactUs}
                            contactInfo={config?.businessContactInfo}
                        />
                    </div>
                </When>
            </StyledHeader>
        </AnalyticsTargetLayerAreaProvider>
    );
};
